import React, { useState, useEffect } from 'react';
import Navbar from './Navbar'
import './Algorithms.css'
import { Link } from 'react-router-dom'
import { auth, database } from './firebase';
import logo from './images/semicolon.png'

function OOP() {

  const [loggedIn, setLoggedIn] = useState(false);
  const [userQuestions, setUserQuestions] = useState([]);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setLoggedIn(true);
        fetchUserQuestions(user.uid);
      } else {
        setLoggedIn(false);
      }
    });

    return unsubscribe()
  }, [auth]);

  const fetchUserQuestions = (userId) => {
    const userRef = database.ref('users').child(userId).child('questions');
    userRef.on('value', (snapshot) => {
      const questionsData = snapshot.val();
      if (questionsData) {
        const questionsArray = Object.values(questionsData);
        setUserQuestions(questionsArray);
      }
    });
  };

  return (
    <div className='algorithms-container'>
        <Navbar />
        <div className='logo-container'>
          <Link to='/'>
          <img src={logo} className='logo' alt='logo' />
          </Link>
        </div>
        <div className='message'>
          <h1>
            SORRY !
          </h1>
          <p>
          Dear mobile user, we know you like convenience, but trust us when we say the desktop experience of this web app will blow your tiny mobile mind. Don't settle for less switch to desktop view and unleash your awesome powers!
          </p>
        </div>
        {loggedIn ? (
        <div className='algo-hide'>
          <div className='algo_tb'>
              <p>Problem</p>
              <p>Difficulty</p>
          </div>
          <div className='prob_diff'>
              <div className='algorithms'>
                  <Link to='/problems/bank-account' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Create a Class for Bank Account') ? 'submitted' : ''}`}>Create a Class for Bank Account</p>
                  </Link>
                  <Link to='/problems/rectangle' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Create a Class for Rectangle') ? 'submitted' : ''}`}>Create a Class for Rectangle</p>
                  </Link>
                  <Link to='/problems/student' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Create a Class for Student') ? 'submitted' : ''}`}>Create a Class for Student</p>
                  </Link>
                  <Link to='/problems/calculator' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Create a Class for Calculator') ? 'submitted' : ''}`}>Create a Class for Calculator</p>
                  </Link>
                  <Link to='/problems/email' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Create a Class for Email') ? 'submitted' : ''}`}>Create a Class for Email</p>
                  </Link>
                  <Link to='/problems/library' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Create a Class for Library') ? 'submitted' : ''}`}>Create a Class for Library</p>
                  </Link>
                  <Link to='/problems/employee-department' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Create a Class for Employee and Department') ? 'submitted' : ''}`}>Create a Class for Employee and Department</p>
                  </Link>
                  <Link to='/problems/shape-hierarchy' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Create a Class for Shape Hierarchy') ? 'submitted' : ''}`}>Create a Class for Shape Hierarchy</p>
                  </Link>
                  <Link to='/problems/online-shopping' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Create a Class for Online Shopping System') ? 'submitted' : ''}`}>Create a Class for Online Shopping System</p>
                  </Link>
                  <Link to='/problems/inventory-mgmt' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Create a Class for Inventory Management') ? 'submitted' : ''}`}>Create a Class for Inventory Management</p>
                  </Link>
              </div>
              <div className='diff'>
                  <p>Easy</p>
                  <p>Easy</p>
                  <p>Easy</p>
                  <p>Easy</p>
                  <p>Easy</p>
                  <p>Medium</p>
                  <p>Medium</p>
                  <p>Medium</p>
                  <p>Hard</p>
                  <p>Hard</p>
              </div>
          </div>
        </div>
        ) : (
          <div>
            <h2>Please sign up/login to see this page</h2>
          </div>
        )}
    </div>
  )
}

export default OOP